import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonList,
  IonButtons,
  IonButton,
  IonSelect,
  IonSelectOption,
  IonInput,
  IonBackButton,
  withIonLifeCycle,
  isPlatform,
  IonModal,
  IonGrid,
  IonCol,
  IonRow,
  IonLabel,
  IonImg,
  IonSlides,
  IonSlide,
  IonPopover,
} from "@ionic/react";
import { RouteComponentProps, withRouter } from "react-router";
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from "react-zoom-pan-pinch";

import { Toast } from "@capacitor/toast";

import { TextToSpeech, TTSOptions } from "@capacitor-community/text-to-speech";

import _ from "lodash";
import { format, subDays } from "date-fns";

// Images
import iconAccessibility from "../../assets/Button_Accessibility@3x.png";
import buttonClose from "../../assets/Button_Close@3x.png";
import iconBookmarkActive from "../../assets/Button_Bookmark_2Active@3x.png";
import iconBookmarkInactive from "../../assets/Button_Bookmark_1Inactive@3x.png";
import iconExpandAdd from "../../assets/Button_Expand_Add@3x.png";
import iconExpandAddDark from "../../assets/Button_Expand_Add@3x.png";
import iconExpandMinus from "../../assets/Button_Expand_Minus@3x.png";
import iconExpandMinusDark from "../../assets/Button_Expand_Minus@3x.png";
import iconPlayWhite from "../../assets/Button_Audio_Play_White@3x.png";
import iconStop from "../../assets/Button_Audio_Stop@3x.png";

// CSS
import "../pathways/PathwayPage.css";
import "../../Shared.css";
import "../../../App.css";

// Controllers
import {
  IScreenProps,
  IUser,
  IGuideline,
  IGuidelineSummary,
  IClinicalNotice,
  IPathway,
  IPathwayBypassNumber,
  IPathwayWhatGoesWhere,
  IPathwayLocationDetail,
} from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import DataController from "../../controllers/DataController";
import RemoteDataController from "../../controllers/RemoteDataController";

// Components
import GuidelineCell from "../../components/GuidelineCell";
import ClinicalNoticeCell from "../../components/ClinicalNoticeCell";
import FontPopover from "../../components/FontPopover";
import ImageViewerModal from "../../components/ImageViewerModal";

type Props = RouteComponentProps<{ id: string; tab: string }> & {
  screenProps: IScreenProps;
  features: string[];
};
type State = {
  showSearch: boolean;
  searchText: string;
  pathwayFilter1Value: string;
  pathwayFilter2Value: string;
  pathwayFilter3Value: string;
  imageModalVisible: boolean;
  fontModalVisible: boolean;
  fontModalEvent: any;
  imageSrc: string;
  openCards: string[];
  remainingTextToSpeechText: string;
};

class PathwayPage extends Component<Props, State> {
  private searchTextField: React.RefObject<HTMLIonInputElement>;
  private imageModalZoom: React.RefObject<ReactZoomPanPinchRef>;

  constructor(props: Props) {
    super(props);

    this.searchTextField = React.createRef();
    this.imageModalZoom = React.createRef();

    let openCards = ["Inclusion criteria", "Exclusion criteria", "Referral Process", "Notes", "PDF"];
    if (this.props.features.includes("pathwaySectionsStartCollapsed")) {
      openCards = [];
    }

    this.state = {
      showSearch: false,
      searchText: "",
      pathwayFilter1Value: "ALL",
      pathwayFilter2Value: "ALL",
      pathwayFilter3Value: "ALL",
      imageModalVisible: false,
      fontModalVisible: false,
      fontModalEvent: null,
      imageSrc: "",
      openCards: openCards,
      remainingTextToSpeechText: "",
    };
  }

  async componentDidMount() {
    document.addEventListener("click", this.handleClickEvent);

    let pathway = this.getPathway();

    if (pathway != null && this.props.screenProps.user != null) {
      await this.props.screenProps.saveRecentlyViewed("", null, null, pathway.id, "pathway");
    }

    this.logPathway();
  }

  ionViewWillLeave() {
    // back.remove();
    this.stopReading();
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (document != null) {
      let locationGroupHeaderElements = document.getElementsByClassName("area-group");

      for (
        let locationGroupHeaderIndex = 0;
        locationGroupHeaderIndex < locationGroupHeaderElements.length;
        locationGroupHeaderIndex++
      ) {
        let locationGroupHeaderElement = locationGroupHeaderElements.item(locationGroupHeaderIndex);

        if (locationGroupHeaderElement) {
          locationGroupHeaderElement.addEventListener("click", this.cardHeaderClicked.bind(this));
        }
      }
    }
  }

  logPathway() {
    let pathwayData = this.props.screenProps.pathwayData;
    if (pathwayData != null) {
      let selectedID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
      let pathway: IPathway | IPathwayBypassNumber | IPathwayWhatGoesWhere | undefined = pathwayData.Pathways.find(
        (pathway) => pathway.id === selectedID
      );
      if (pathway == null) {
        pathway = pathwayData.Bypassnumbers.find((bypassNumber) => bypassNumber.id === selectedID);
      }
      if (pathway == null) {
        pathway = pathwayData.Whatgoeswhere.find((wgw) => wgw.id === selectedID);
      }

      if (pathway != null) {
        let pathwayID = pathway.id;
        let name = "";
        let updated = pathwayData.updated;

        if (DataController.isPathway(pathway)) {
          if (pathway.fields["Pathway name"]) {
            name = pathway.fields["Pathway name"];
          }
        } else if (DataController.isBypassNumber(pathway)) {
          if (pathway.fields["Pathway category"]) {
            name = pathway.fields["Pathway category"];
          }
        } else if (DataController.isWhatGoesWhere(pathway)) {
          if (pathway.fields.Name) {
            name = pathway.fields.Name;
          }
        }

        RemoteDataController.logUsage(
          null,
          null,
          null,
          { id: pathwayID, name: name, updated: updated },
          null,
          false,
          "",
          this.props.screenProps.user,
          this.props.screenProps.app
        );
      }
    }
  }

  handleBackEvent = (event: any) => {
    if (this.state.imageModalVisible) {
      this.setState({
        imageModalVisible: false,
      });
    } else if (this.state.fontModalVisible) {
      this.setState({
        fontModalVisible: false,
      });
    } else {
      // console.log(event);
    }
  };

  handleClickEvent = (event: any) => {
    if (event.srcElement.localName === "img" && event.srcElement.className === "img11") {
      if (this.props.match.url === event.currentTarget.location.pathname) {
        this.toggleImageModal(true, event.srcElement);
      }
    }
  };

  getPathway() {
    let pathwayData = this.props.screenProps.pathwayData;

    if (pathwayData != null) {
      let selectedID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
      let pathway: IPathway | IPathwayBypassNumber | IPathwayWhatGoesWhere | undefined = pathwayData.Pathways.find(
        (pathway) => pathway.id === selectedID
      );
      if (pathway == null) {
        pathway = pathwayData.Bypassnumbers.find((bypassNumber) => bypassNumber.id === selectedID);
      }
      if (pathway == null) {
        pathway = pathwayData.Whatgoeswhere.find((wgw) => wgw.id === selectedID);
      }

      if (pathway != null) {
        if (DataController.isPathway(pathway)) {
          return pathway;
        }
      }
    }

    return null;
  }

  toggleFontModal(value: boolean, event: any) {
    this.setState({
      fontModalVisible: value,
      fontModalEvent: event,
    });
    if (value === true) {
      RemoteDataController.logEvent("accessability_popover_opened", {
        from: "pathway",
      });
    }
  }

  toggleImageModal(value: boolean, srcElement?: any) {
    this.props.screenProps.showStatusBar(value, "#008477");

    if (srcElement) {
      let html = srcElement.outerHTML
        .replace('class="algorithmImage"', "")
        .replace('class="algorithmImage algorithmImageMobile"', "");

      this.setState({
        imageSrc: html,
        imageModalVisible: value,
      });
    } else {
      this.setState({
        imageModalVisible: value,
      });
    }
  }

  fontSize(size: number) {
    return `${size + this.props.screenProps.fontSizeChange}px`;
  }

  async readPathway() {
    try {
      await this.stopReading();
      await DataController.waitForMilliseconds(500);

      let content: HTMLElement | null = null;

      let tab = this.props.match.params.tab;

      content = document.getElementById("pathway-content");

      let text: string = "";

      if (content != null && content.innerText != null) {
        text = content.innerText;
        text = text.replace(/\n/g, ". ");
        text = text.replace(/\.\./g, ".");
        text = text.replace(/Play section/g, "");
        if (text.startsWith(". ")) {
          text = text.slice(2); // remove leading period space
        }

        let supportedLanguages = await TextToSpeech.getSupportedLanguages();

        if (supportedLanguages.languages.length > 0) {
          let remainingText = text + "";
          await this.setStateAsync({ remainingTextToSpeechText: remainingText });

          while (this.state.remainingTextToSpeechText.length > 0) {
            let text = this.state.remainingTextToSpeechText.substring(0, 3000);

            remainingText = this.state.remainingTextToSpeechText.substring(3000);

            await this.setStateAsync({ remainingTextToSpeechText: remainingText });

            let speechSpeed = DataController.convertTextToSpeechSpeed(this.props.screenProps.textToSpeechSpeed);

            let textToSpeechProperties: TTSOptions = {
              text: text,
              rate: speechSpeed,
              pitch: 1.0,
              volume: 1.0,
              category: "playback",
            };

            if (supportedLanguages.languages.includes("en-GB")) {
              textToSpeechProperties.lang = "en-GB";
            }

            await TextToSpeech.speak(textToSpeechProperties);

            try {
              RemoteDataController.logEvent("text_spoken", {
                from: "pathway",
              });
            } catch (error) {}
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async stopReading() {
    await this.setStateAsync({ remainingTextToSpeechText: "" });
    await TextToSpeech.stop();
  }

  cardHeaderClicked = _.debounce((e: any) => {
    // debounced method as it was being called multiple times
    let element = null;
    if (e != null && e.target != null) {
      if (e.target.localName === "img") {
        element = e.target.parentElement;
      } else {
        element = e.target;
      }

      if (element != null) {
        let cardTitle = element.innerText.trim();
        let openCards = this.state.openCards;

        if (openCards.includes(cardTitle)) {
          openCards = openCards.filter((e) => e !== cardTitle);
        } else {
          openCards.push(cardTitle);
        }

        this.setState({ openCards });
      }
    }
  }, 100);

  locationDetails(locationDetailIDs: string[], shouldGroup: boolean) {
    let locationDetailsHtml = "";
    let pathwayData = this.props.screenProps.pathwayData;

    let locationDetails: IPathwayLocationDetail[] = [];
    let locationDetailGroups: { area: string; locationDetails: IPathwayLocationDetail[] }[] = [];

    if (pathwayData != null) {
      if (locationDetailIDs) {
        for (let locationDetailID of locationDetailIDs) {
          let locationDetail = pathwayData.LocationDetails.find(
            (locationDetail) => locationDetail.id === locationDetailID
          );
          if (locationDetail) {
            if (shouldGroup) {
              if (this.props.features.includes("pathwayHealthBoards")) {
                if (locationDetail.fields["Health Board"] != null) {
                  let areas = locationDetail.fields["Health Board"];
                  for (let area of areas) {
                    let locationDetailGroup = locationDetailGroups.find(
                      (locationDetailGroup) => locationDetailGroup.area === area
                    );
                    if (locationDetailGroup != null) {
                      locationDetailGroup.locationDetails.push(locationDetail);
                    } else {
                      locationDetailGroups.push({ area: area, locationDetails: [locationDetail] });
                    }
                  }
                }
              } else {
                if (locationDetail.fields.Area != null) {
                  let areas = locationDetail.fields.Area;
                  for (let area of areas) {
                    let locationDetailGroup = locationDetailGroups.find(
                      (locationDetailGroup) => locationDetailGroup.area === area
                    );
                    if (locationDetailGroup != null) {
                      locationDetailGroup.locationDetails.push(locationDetail);
                    } else {
                      locationDetailGroups.push({ area: area, locationDetails: [locationDetail] });
                    }
                  }
                }
              }
            } else {
              let locationDetailGroup = locationDetailGroups.find(
                (locationDetailGroup) => locationDetailGroup.area === "All"
              );
              if (locationDetailGroup != null) {
                locationDetailGroup.locationDetails.push(locationDetail);
              } else {
                locationDetailGroups.push({ area: "All", locationDetails: [locationDetail] });
              }
            }
          }
        }

        locationDetailGroups.sort((a, b) => {
          if (a.area < b.area) {
            return -1;
          }
          if (a.area > b.area) {
            return 1;
          }
          return 0;
        });

        for (let locationDetailGroup of locationDetailGroups) {
          if (shouldGroup) {
            let collapsedIcon = "Button_Expand_Add@3x.png";
            if (this.props.screenProps.darkMode) {
              collapsedIcon = "Button_Expand_Add@3x.png";
            }

            if (this.state.openCards.includes(locationDetailGroup.area)) {
              if (this.props.screenProps.darkMode) {
                collapsedIcon = "Button_Expand_Minus@3x.png";
              } else {
                collapsedIcon = "Button_Expand_Minus@3x.png";
              }
            }

            locationDetailsHtml +=
              '<div key="' +
              locationDetailGroup.area +
              '" class="card pathway-card area-group"><div class="pathway-card-header item-divider">' +
              locationDetailGroup.area +
              '<img height="44" src="img/' +
              collapsedIcon +
              '"></img> </div>';
          } else {
            locationDetailsHtml = "<div>";
          }

          if (this.state.openCards.includes(locationDetailGroup.area) || locationDetailGroup.area === "All") {
            for (let locationDetail of locationDetailGroup.locationDetails) {
              locationDetails.sort((a, b) => {
                if (a.fields.Contact && b.fields.Contact) {
                  let aTitle = a.fields.Contact.toLowerCase();
                  let bTitle = b.fields.Contact.toLowerCase();
                  if (aTitle < bTitle) {
                    return -1;
                  }
                  if (aTitle > bTitle) {
                    return 1;
                  }
                }
                return 0;
              });

              locationDetailsHtml += "<div key=" + locationDetail.id + ' class="location-details-container">';
              locationDetailsHtml +=
                "<div key=" +
                locationDetail.id +
                " class=pathway-location-title>" +
                locationDetail.fields["Contact"] +
                "</div>";
              locationDetailsHtml += "<div class=pathway-location-place-div>";
              if (
                locationDetail.fields["Opening Times display"] &&
                locationDetail.fields["Opening Times display"].length > 0
              ) {
                locationDetailsHtml += '<div class="opening-div">';
                locationDetailsHtml +=
                  '<img style="float:left; margin-left=-50px;" height="24" src="img/Glyph_Clock@3x.png"></img>';
                locationDetailsHtml += "<div class=opening-times>";
                locationDetailsHtml += locationDetail.fields["Opening Times display"];
                locationDetailsHtml += "</div>";
                locationDetailsHtml += "</div>";
              }
              if (locationDetail.fields["Phone Number"]) {
                locationDetailsHtml += "<div class=phone-div>";
                locationDetailsHtml +=
                  '<img style="float:left; margin-right: 4px" height="24" src="img/Glyph_Phone@3x.png"></img>';
                locationDetailsHtml +=
                  `<phone_number onclick="window.open('` +
                  this.convertPhoneNumberToLink(locationDetail.fields["Phone Number"]) +
                  `', '_blank', 'noreferrer')">` +
                  locationDetail.fields["Phone Number"] +
                  `</phone_number>`;
                if (this.props.features.includes("pathwayFeedback")) {
                  locationDetailsHtml += `<ion-select interface='action-sheet' id="${`${locationDetail.id}_${locationDetail.fields["Phone Number"]}`}" class='pathwayLocationFeedbackSelect' placeholder="Provide Feedback">
                                              <ion-select-option value="Referral Accepted">Referral Accepted</ion-select-option>
                                              <ion-select-option value="Referral Not Accepted">Referral Not Accepted</ion-select-option>
                                              <ion-select-option value="Call Not Answered">Call Not Answered</ion-select-option>
                                            </ion-select>`;
                }
                locationDetailsHtml += "</div>";
              }
              if (locationDetail.fields["Phone Number 2"]) {
                locationDetailsHtml += "<div class=phone-div>";
                locationDetailsHtml +=
                  '<img style="float:left; margin-right: 4px" height="24" src="img/Glyph_Phone@3x.png"></img>';
                locationDetailsHtml +=
                  `<phone_number onclick="window.open('` +
                  this.convertPhoneNumberToLink(locationDetail.fields["Phone Number 2"]) +
                  `', '_blank', 'noreferrer')">` +
                  locationDetail.fields["Phone Number 2"] +
                  `</phone_number>`;
                if (this.props.features.includes("pathwayFeedback")) {
                  locationDetailsHtml += `<ion-select interface='action-sheet' id="${`${locationDetail.id}_${locationDetail.fields["Phone Number 2"]}`}" class='pathwayLocationFeedbackSelect' placeholder="Provide Feedback">
                                              <ion-select-option value="Referral Accepted">Referral Accepted</ion-select-option>
                                              <ion-select-option value="Referral Not Accepted">Referral Not Accepted</ion-select-option>
                                              <ion-select-option value="Call Not Answered">Call Not Answered</ion-select-option>
                                            </ion-select>`;
                }
                locationDetailsHtml += "</div>";
              }
              if (locationDetail.fields["Phone Number 3"]) {
                locationDetailsHtml += "<div class=phone-div>";
                locationDetailsHtml +=
                  '<img style="float:left; margin-right: 4px" height="24" src="img/Glyph_Phone@3x.png"></img>';
                locationDetailsHtml +=
                  `<phone_number onclick="window.open('` +
                  this.convertPhoneNumberToLink(locationDetail.fields["Phone Number 3"]) +
                  `', '_blank', 'noreferrer')">` +
                  locationDetail.fields["Phone Number 3"] +
                  `</phone_number>`;
                if (this.props.features.includes("pathwayFeedback")) {
                  locationDetailsHtml += `<ion-select interface='action-sheet' id="${`${locationDetail.id}_${locationDetail.fields["Phone Number 3"]}`}" class='pathwayLocationFeedbackSelect' placeholder="Provide Feedback">
                                              <ion-select-option value="Referral Accepted">Referral Accepted</ion-select-option>
                                              <ion-select-option value="Referral Not Accepted">Referral Not Accepted</ion-select-option>
                                              <ion-select-option value="Call Not Answered">Call Not Answered</ion-select-option>
                                            </ion-select>`;
                }
                locationDetailsHtml += "</div>";
              }
              if (locationDetail.fields["Email"]) {
                locationDetailsHtml += "<div class=phone-div>";
                locationDetailsHtml +=
                  '<img style="float:left; margin-right: 4px" height="24" src="img/Glyph_Email@3x.png"></img>';
                locationDetailsHtml +=
                  `<phone_number onclick="window.open('` +
                  this.convertEmailToLink(locationDetail.fields["Email"]) +
                  `', '_blank', 'noreferrer')">` +
                  locationDetail.fields["Email"] +
                  `</phone_number>`;
                locationDetailsHtml += "</div>";
              }

              let placeIDs = locationDetail.fields["Location"];

              if (placeIDs && placeIDs.length > 0) {
                locationDetailsHtml += '<div class="place-div">';
                locationDetailsHtml +=
                  '<img style="float:left; margin-left: 2px; margin-right: 2px" height="24" src="img/Glyph_Location@3x.png"></img>';
                locationDetailsHtml += "<div class=opening-times>";

                for (let placeID of placeIDs) {
                  let aPlace = pathwayData.Places.find((place) => place.id === placeID);
                  if (aPlace) {
                    if (aPlace.fields["Abbreviation"]) {
                      locationDetailsHtml +=
                        "<span>" + aPlace.fields["Title"] + " (" + aPlace.fields["Abbreviation"] + ")</span>";
                    } else {
                      locationDetailsHtml += "<span>" + aPlace.fields["Title"] + "</span>";
                    }
                    if (aPlace.fields["Address"]) {
                      locationDetailsHtml +=
                        "<profile_content_address>" + aPlace.fields["Address"] + "</profile_content_address>";
                    }
                    if (aPlace.fields["Town/City"]) {
                      locationDetailsHtml +=
                        "<profile_content_city>" + aPlace.fields["Town/City"] + "</profile_content_city>";
                    }
                    if (aPlace.fields["PostcodeTown"]) {
                      let googleMapsLink =
                        "https://www.google.com/maps/search/?api=1&query=" + encodeURI(aPlace.fields["PostcodeTown"]);

                      locationDetailsHtml +=
                        `<profile_content_postcode><postcode onclick="window.open('` +
                        googleMapsLink +
                        `', '_blank', 'noreferrer')">` +
                        aPlace.fields["PostcodeTown"] +
                        `</postcode></profile_content_postcode>`;
                    }
                  }
                }

                locationDetailsHtml += "</div>";
                locationDetailsHtml += "</div>";
              }

              locationDetailsHtml += "</div>";

              locationDetailsHtml += "</div>";
            }
          }

          locationDetailsHtml += "</div>";
        }
      }
    }

    return locationDetailsHtml;
  }

  whatGoesWhereSectionHTML(wgw: IPathwayWhatGoesWhere, section: string) {
    let html = "";
    let title = "";

    if (section === "1" || section === "2" || section === "3" || section === "4") {
      let sectionHtml = wgw.fields[section];
      let locationDetailsHtml = "";

      if (sectionHtml) {
        let sectionParts = sectionHtml.split("\n");
        if (sectionParts.length > 1) {
          title = sectionParts[0];
        }

        let sectionLocationDetailsKey = section + " location details";
        let sectionLocationDetailIDs: string[] = [];
        if (
          sectionLocationDetailsKey === "1 location details" ||
          sectionLocationDetailsKey === "2 location details" ||
          sectionLocationDetailsKey === "3 location details" ||
          sectionLocationDetailsKey === "4 location details"
        ) {
          let possibleSectionLocationDetailIDs = wgw.fields[sectionLocationDetailsKey];
          if (possibleSectionLocationDetailIDs != null) {
            sectionLocationDetailIDs = possibleSectionLocationDetailIDs;
          }
        }

        if (sectionLocationDetailIDs.length > 0) {
          locationDetailsHtml = this.locationDetails(sectionLocationDetailIDs, false);
        }

        html +=
          `
        <div class="card pathway-card">
          <div class="pathway-card-header item-divider DOSDivider">
            ` +
          this.convertToHTML(title) +
          `
          </div>
          <div class="padding">
            ` +
          this.convertToHTML(sectionHtml) +
          `
            ` +
          this.convertToHTML(locationDetailsHtml) +
          `
          </div>
        </div>`;
      }
    }

    return html;
  }

  convertToHTML(text: string) {
    let html = text.trim().replace(/\n\n/g, "\n");
    html = html.replace(/\n/g, "<br/><br/>");
    return html;
  }

  convertPhoneNumberToLink(text: string) {
    var phoneNumber = text;
    var colonIndex = phoneNumber.indexOf(":");
    if (colonIndex != -1) {
      phoneNumber = phoneNumber.substring(colonIndex + 1);
    }
    var openBracketIndex = phoneNumber.indexOf("(");
    if (openBracketIndex != -1) {
      phoneNumber = phoneNumber.substring(0, openBracketIndex);
    }
    phoneNumber = phoneNumber.replace(/ /g, "");

    return "tel:" + phoneNumber;
  }

  convertEmailToLink(text: string) {
    try {
      var email = text;
      var colonIndex = email.indexOf(":");
      if (colonIndex != -1) {
        email = email.substring(colonIndex + 1);
      }
      var openBracketIndex = email.indexOf("(");
      if (openBracketIndex != -1) {
        email = email.substring(0, openBracketIndex);
      }
      email = email.replace(/ /g, "");

      return "mailto:" + email;
    } catch (error) {
      return text;
    }
  }

  bookmarkButtonPressed() {
    let pathway = this.getPathway();

    if (pathway != null) {
      this.props.screenProps.saveBookmark("", null, null, pathway.id, "pathway");
    }
  }

  isBookmarked() {
    let pathway = this.getPathway();

    if (pathway != null) {
      let bookmark = _.find(this.props.screenProps.bookmarks, { pathwayID: pathway.id, type: "pathway" });
      return bookmark != null;
    }

    return false;
  }

  iconForCardHeader(isOpen: boolean, darkMode: boolean) {
    if (isOpen) {
      if (darkMode) {
        return iconExpandMinusDark;
      } else {
        return iconExpandMinus;
      }
    } else {
      if (darkMode) {
        return iconExpandAddDark;
      } else {
        return iconExpandAdd;
      }
    }
  }

  pathwayLocationFeedbackSelectChanged = _.debounce(async (e: any) => {
    // debounced method as it was being called multiple times
    try {
      let pathwayData = this.props.screenProps.pathwayData;

      if (this.props.screenProps.user && pathwayData != null) {
        let selectedID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);

        let pathway: IPathway | IPathwayBypassNumber | IPathwayWhatGoesWhere | undefined = pathwayData.Pathways.find(
          (pathway) => pathway.id === selectedID
        );
        if (pathway == null) {
          pathway = pathwayData.Bypassnumbers.find((bypassNumber) => bypassNumber.id === selectedID);
        }
        if (pathway == null) {
          pathway = pathwayData.Whatgoeswhere.find((wgw) => wgw.id === selectedID);
        }

        let pathwayName = "";

        if (pathway != null) {
          pathwayName = DataController.getPathwayName(pathway);
        }

        let locationDetailParts: string[] = e.srcElement.id.split("_");
        let locationDetailID = locationDetailParts[0];
        let locationDetailPhoneNumber = locationDetailParts[1];
        let locationDetailName = "";

        let locationDetail = pathwayData.LocationDetails.find(
          (locationDetail) => locationDetail.id === locationDetailID
        );

        if (locationDetail != null) {
          if (locationDetail.fields.Contact) {
            locationDetailName = locationDetail.fields.Contact;
          }

          await RemoteDataController.sendPathwayFeedback(
            selectedID,
            pathwayName,
            locationDetailID,
            locationDetailName,
            locationDetailPhoneNumber,
            e.detail.value,
            this.props.screenProps.user
          );
        }

        Toast.show({
          text: "Feedback sent",
        });
      }
    } catch (error) {}
  }, 100);

  setStateAsync(state: any) {
    return new Promise((resolve: any) => {
      this.setState(state, resolve);
    });
  }

  render() {
    let pathwayData = this.props.screenProps.pathwayData;

    if (pathwayData == null) {
      let messageText = "Pathway is loading";

      if (this.props.screenProps.messageBarText === "") {
        messageText = "Pathway couldn't be loaded. It might not exist or has been removed.";
      }

      return (
        <IonPage>
          <IonHeader>
            <IonToolbar mode="ios" className="navBar">
              <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
                <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <div className="emptyPageContainer">
              <div className="emptyPageText">{messageText}</div>
            </div>
          </IonContent>
        </IonPage>
      );
    }

    let trust = this.props.screenProps.trust;

    // add event listener to each ion-select location feedback
    const locationFeedbackSelects = document.getElementsByClassName("pathwayLocationFeedbackSelect");
    if (locationFeedbackSelects != null && locationFeedbackSelects.length > 0) {
      for (
        let locationFeedbackSelectIndex = 0;
        locationFeedbackSelectIndex < locationFeedbackSelects.length;
        locationFeedbackSelectIndex++
      ) {
        let locationFeedbackSelect = locationFeedbackSelects[locationFeedbackSelectIndex];
        locationFeedbackSelect.addEventListener("ionChange", (e: any) => {
          this.pathwayLocationFeedbackSelectChanged(e);
        });
      }
    }

    let contentLayout = null;
    let isBookmarked = false;

    let selectedID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
    let pathway: IPathway | IPathwayBypassNumber | IPathwayWhatGoesWhere | undefined = pathwayData.Pathways.find(
      (pathway) => pathway.id === selectedID
    );
    if (pathway == null) {
      pathway = pathwayData.Bypassnumbers.find((bypassNumber) => bypassNumber.id === selectedID);
    }
    if (pathway == null) {
      pathway = pathwayData.Whatgoeswhere.find((wgw) => wgw.id === selectedID);
    }

    let pathwayContactMessageLayout = null;
    let pathwayContactEmail = "";
    if (this.props.screenProps.trustInfo) {
      if (this.props.screenProps.trust !== "") {
        let trustInfo = this.props.screenProps.trustInfo.find(
          (trustInfo) => trustInfo.trust === this.props.screenProps.trust
        );
        if (trustInfo != null && trustInfo.pathwayContactEmail != null) {
          pathwayContactEmail = trustInfo.pathwayContactEmail;
        }
      }
    }

    let majorChangeLayout = null;

    if (pathway != null && pathway.fields["Major changes"] != null && pathway.fields["Major changes"] !== "") {
      if (pathway.fields["Last modified time"] != null) {
        let dateText = "";
        let lastModifiedDate = new Date(pathway.fields["Last modified time"]);
        dateText = format(lastModifiedDate, "dd/MM/yyyy");

        let today = new Date();
        let thirtyDaysAgo = subDays(today, 30);

        if (thirtyDaysAgo < lastModifiedDate) {
          // modified less than 30 days ago
          let descriptionHtml = this.convertToHTML(pathway.fields["Major changes"]);

          majorChangeLayout = (
            <div className="pathwaySignificantChangeWarningCard significantChangeWarningCard">
              <div className="significantChangeWarningCardContents">
                <div className="significantChangeWarningCardDate">
                  <div className="significantChangeWarningCardUpdate">UPDATE</div>
                  {dateText}
                </div>

                <div
                  className="significantChangeWarningCardDescription"
                  dangerouslySetInnerHTML={{ __html: descriptionHtml }}
                />
              </div>
            </div>
          );
        }
      }
    }

    if (
      this.props.features.includes("pathwayContactMessage") &&
      pathwayContactEmail != null &&
      pathwayContactEmail !== ""
    ) {
      let emailSubject = "Pathway Feedback";
      if (pathway != null) {
        if (DataController.isPathway(pathway)) {
          if (pathway.fields["Pathway name"]) {
            emailSubject = "Pathway Feedback: " + pathway.fields["Pathway name"];
          }
        } else if (DataController.isWhatGoesWhere(pathway)) {
          if (pathway.fields.Name) {
            emailSubject = "Pathway Feedback: " + pathway.fields.Name;
          }
        } else {
          if (pathway.fields["Pathway category"]) {
            emailSubject = "Pathway Feedback: " + pathway.fields["Pathway category"];
          }
        }
      }

      pathwayContactMessageLayout = (
        <div className="pathway-contact-email">
          If there is a problem with this pathway, please contact{" "}
          <a href={`mailto:${pathwayContactEmail}?subject=${emailSubject}`}>{pathwayContactEmail}</a>
        </div>
      );
    }

    let showBookmarkButton = false;

    if (pathway != null) {
      if (DataController.isPathway(pathway)) {
        let pathwayName = "";
        if (pathway.fields["Pathway name"]) {
          pathwayName = pathway.fields["Pathway name"];
        }

        let pathwayAreas: string[] = [];
        if (pathway.fields.Area) {
          pathwayAreas = pathway.fields.Area;
        }

        let pathwayHealthBoards: string[] = [];
        if (pathway.fields["Health Board"]) {
          pathwayHealthBoards = pathway.fields["Health Board"];
        }

        let pathwayCategory = "";
        let pathwayCategoryIDs = pathway.fields["Pathway Categories"];
        let pathwayCategories = [];
        let pathwayTypes = [];
        if (pathwayCategoryIDs) {
          for (let pathwayCategoryID of pathwayCategoryIDs) {
            let category = pathwayData.categories.find((category) => category.id === pathwayCategoryID);
            if (category != null) {
              if (category.fields.Category != null) {
                pathwayCategories.push(category.fields.Category);
              }
              if (category.fields["Pathway Type"] != null) {
                pathwayTypes.push(category.fields["Pathway Type"]);
              }
            }
          }
        }

        if (pathwayCategories.length > 0) {
          pathwayCategory = pathwayCategories.join(", ");
        }

        var locationDetailsHtml = "";
        if (pathway.fields["Location details"]) {
          let groupLocations = false;
          if (pathway.fields.GroupLocationAreas) {
            groupLocations = pathway.fields.GroupLocationAreas;
          }

          locationDetailsHtml = this.locationDetails(pathway.fields["Location details"], groupLocations);
        }

        let pathwayImages = pathway.fields.PathwayImage;
        let pathwayImageSrc = "";
        if (pathwayImages) {
          for (let pathwayImage of pathwayImages) {
            let pathwayImageName = DataController.getPathWayImageName(pathway, pathwayImage.filename);
            let image = this.props.screenProps.images.find((image) => image.name === pathwayImageName);
            if (image != null) {
              pathwayImageSrc = image.data;
            }
          }
        }

        isBookmarked = this.isBookmarked();
        showBookmarkButton = true;

        let pdfLink = null;
        if (pathway.fields.PDF && pathway.fields.PDF.length > 0) {
          let pdfFilename = pathway.fields["Pathway ID"] + pathway.fields.PDF[0].filename;
          pdfFilename = pdfFilename.replace(/ /g, ""); // todo changed regex - check still works
          pdfFilename = pdfFilename.replace(/%20/g, "");
          pdfFilename = pdfFilename.replace(" ", "");
          pdfLink = `https://aace.s3.amazonaws.com/${this.props.screenProps.trust}/${pdfFilename}`;
        }

        let showAuthorisedUsersWarning = this.props.features.includes("pathwayAuthorisedUsersWarning");

        contentLayout = (
          <div className="pathway-details">
            {majorChangeLayout}
            <div className="pathway-title">{pathwayName}</div>
            {pathway.fields.AuthorisedUsers && showAuthorisedUsersWarning ? (
              <div className="pathway-authorised-users-warning-container">
                <div className="pathway-authorised-users-warning-title">Authorised Users Only</div>
                <div className="pathway-authorised-users-warning">{pathway.fields.AuthorisedUsers}</div>
              </div>
            ) : null}
            {pathway.fields.AuthorisedUsers && showAuthorisedUsersWarning === false ? (
              <div className="pathway-authorised-users">
                <strong>Authorised Users:</strong> {pathway.fields.AuthorisedUsers}
              </div>
            ) : null}
            <div className="pathway-area-div">{pathwayAreas.join(", ")}</div>
            <div className="pathway-area-div">{pathwayHealthBoards.join(", ")}</div>
            <div className="pathway-type">
              {pathwayTypes.join(", ")} {pathwayTypes.length > 0 ? "|" : ""} {pathwayCategory}
            </div>
            {locationDetailsHtml !== "" ? (
              <div
                className="pathway-location"
                dangerouslySetInnerHTML={{ __html: this.convertToHTML(locationDetailsHtml) }}
              />
            ) : null}
            {pathwayImageSrc !== "" && this.props.features.includes("pathwayImagesBelow") === false ? (
              <div className="card pathway-card">
                <div className="padding">
                  <img className="img11" src={pathwayImageSrc} />
                </div>
              </div>
            ) : null}
            {pathway.fields["Inclusion criteria"] ? (
              <div className="card pathway-card">
                <div
                  className="pathway-card-header item-divider DOSDivider"
                  onClick={this.cardHeaderClicked.bind(this)}
                >
                  Inclusion criteria{" "}
                  <img
                    height="44"
                    src={this.iconForCardHeader(
                      this.state.openCards.includes("Inclusion criteria"),
                      this.props.screenProps.darkMode
                    )}
                  ></img>
                </div>
                {this.state.openCards.includes("Inclusion criteria") ? (
                  <div
                    className="padding"
                    dangerouslySetInnerHTML={{ __html: this.convertToHTML(pathway.fields["Inclusion criteria"]) }}
                  />
                ) : null}
              </div>
            ) : null}
            {pathway.fields["Exclusion criteria"] ? (
              <div className="card pathway-card">
                <div
                  className="pathway-card-header item-divider DOSDivider"
                  onClick={this.cardHeaderClicked.bind(this)}
                >
                  Exclusion criteria{" "}
                  <img
                    height="44"
                    src={this.iconForCardHeader(
                      this.state.openCards.includes("Exclusion criteria"),
                      this.props.screenProps.darkMode
                    )}
                  ></img>
                </div>
                {this.state.openCards.includes("Exclusion criteria") ? (
                  <div
                    className="padding"
                    dangerouslySetInnerHTML={{ __html: this.convertToHTML(pathway.fields["Exclusion criteria"]) }}
                  />
                ) : null}
              </div>
            ) : null}
            {pathway.fields["Referral Process"] ? (
              <div className="card pathway-card">
                <div
                  className="pathway-card-header item-divider DOSDivider"
                  onClick={this.cardHeaderClicked.bind(this)}
                >
                  Referral Process{" "}
                  <img
                    height="44"
                    src={this.iconForCardHeader(
                      this.state.openCards.includes("Referral Process"),
                      this.props.screenProps.darkMode
                    )}
                  ></img>
                </div>
                {this.state.openCards.includes("Referral Process") ? (
                  <div
                    className="padding"
                    dangerouslySetInnerHTML={{ __html: this.convertToHTML(pathway.fields["Referral Process"]) }}
                  />
                ) : null}
              </div>
            ) : null}
            {pathway.fields["Notes"] ? (
              <div className="card pathway-card">
                <div
                  className="pathway-card-header item-divider DOSDivider"
                  onClick={this.cardHeaderClicked.bind(this)}
                >
                  Notes{" "}
                  <img
                    height="44"
                    src={this.iconForCardHeader(
                      this.state.openCards.includes("Notes"),
                      this.props.screenProps.darkMode
                    )}
                  ></img>
                </div>
                {this.state.openCards.includes("Notes") ? (
                  <div
                    className="padding"
                    dangerouslySetInnerHTML={{ __html: this.convertToHTML(pathway.fields["Notes"]) }}
                  />
                ) : null}
              </div>
            ) : null}
            {pathwayImageSrc !== "" && this.props.features.includes("pathwayImagesBelow") ? (
              <div className="card pathway-card">
                <div className="padding">
                  <img className="img11" src={pathwayImageSrc} />
                </div>
              </div>
            ) : null}
            {pdfLink ? (
              <div className="card pathway-card">
                <div
                  className="pathway-card-header item-divider DOSDivider"
                  onClick={this.cardHeaderClicked.bind(this)}
                >
                  PDF{" "}
                  <img
                    height="44"
                    src={this.iconForCardHeader(this.state.openCards.includes("PDF"), this.props.screenProps.darkMode)}
                  ></img>
                </div>
                {this.state.openCards.includes("PDF") ? (
                  <a className="padding pathwayPDFLink" href={pdfLink} target="_blank" referrerPolicy="no-referrer">
                    Click to view
                  </a>
                ) : null}
              </div>
            ) : null}
            {pathwayContactMessageLayout}
            {pathway.fields.VersionNumber ? (
              <div className="pathway-version-number">
                <strong>Version Number:</strong> {pathway.fields.VersionNumber}
              </div>
            ) : null}
          </div>
        );
      } else if (DataController.isWhatGoesWhere(pathway)) {
        let pathwayName = "";
        if (pathway.fields["Name"]) {
          pathwayName = pathway.fields["Name"];
        }

        let pathwayImages = pathway.fields.PathwayImage;
        let pathwayImageSrc = "";
        if (pathwayImages) {
          for (let pathwayImage of pathwayImages) {
            let pathwayImageName = DataController.getPathwayWhatGoesWhereImageName(pathway, pathwayImage.filename);
            let image = this.props.screenProps.images.find((image) => image.name === pathwayImageName);
            if (image != null) {
              pathwayImageSrc = image.data;
            }
          }
        }

        let html = "";
        if (pathway.fields["1"]) {
          html += this.whatGoesWhereSectionHTML(pathway, "1");
        }
        if (pathway.fields["2"]) {
          html += this.whatGoesWhereSectionHTML(pathway, "2");
        }
        if (pathway.fields["3"]) {
          html += this.whatGoesWhereSectionHTML(pathway, "3");
        }
        if (pathway.fields["4"]) {
          html += this.whatGoesWhereSectionHTML(pathway, "4");
        }

        contentLayout = (
          <div className="pathway-details">
            <div className="pathway-type">What Goes Where?</div>
            <div className="pathway-title">{pathwayName}</div>

            {pathwayImageSrc !== "" && this.props.features.includes("pathwayImagesBelow") === false ? (
              <div className="card pathway-card">
                <div className="padding">
                  <img className="img11" src={pathwayImageSrc} />
                </div>
              </div>
            ) : null}

            <div className="" dangerouslySetInnerHTML={{ __html: html }} />

            {pathwayImageSrc !== "" && this.props.features.includes("pathwayImagesBelow") ? (
              <div className="card pathway-card">
                <div className="padding">
                  <img className="img11" src={pathwayImageSrc} />
                </div>
              </div>
            ) : null}
          </div>
        );
      } else {
        var locationDetailsHtml = "";
        if (pathway.fields["Location details"]) {
          locationDetailsHtml = this.locationDetails(pathway.fields["Location details"], false);
        }

        let pathwayCategory = "";
        if (pathway.fields["Pathway category"]) {
          pathwayCategory = pathway.fields["Pathway category"];
        }

        contentLayout = (
          <div className="pathway-details">
            {trust === "SAS" ? "Hospital Radio Codes" : "Emergency Bypass Numbers"}
            <div className="pathway-title">{pathwayCategory}</div>
            {locationDetailsHtml !== ""}{" "}
            {
              <div
                className="pathway-location"
                dangerouslySetInnerHTML={{ __html: this.convertToHTML(locationDetailsHtml) }}
              />
            }
          </div>
        );

        let test = pathway;
      }
    }

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonButtons slot="end">
              {this.props.screenProps.showTextToSpeech ? (
                <>
                  <IonButton className="headerButtons audioHeaderButtons" onClick={(event) => this.readPathway()}>
                    <IonImg src={iconPlayWhite} />
                  </IonButton>
                  <IonButton className="headerButtons audioHeaderButtons" onClick={(event) => this.stopReading()}>
                    <IonImg src={iconStop} />
                  </IonButton>
                </>
              ) : null}
              <IonButton className="headerButtons" onClick={(event) => this.toggleFontModal(true, event)}>
                <IonImg src={iconAccessibility} />
              </IonButton>
              {showBookmarkButton ? (
                <IonButton className="headerButtons" onClick={() => this.bookmarkButtonPressed()}>
                  <IonImg src={isBookmarked ? iconBookmarkActive : iconBookmarkInactive} />
                </IonButton>
              ) : null}
            </IonButtons>
            <IonTitle>{this.props.screenProps.showTextToSpeech ? "" : "Pathway Details"}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent id={`pathway-content`} fullscreen>
          <div className="globalContentMargin">{contentLayout}</div>

          {window.innerWidth < 600 ? (
            <IonModal
              mode="ios"
              id="fontModal2"
              showBackdrop={true}
              isOpen={this.state.fontModalVisible}
              initialBreakpoint={1}
              breakpoints={[0, 1]}
              // event={this.state.fontModalEvent}
              backdropDismiss={true}
              onDidDismiss={() => this.toggleFontModal(false, null)}
            >
              <div className="triangle" />
              <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
            </IonModal>
          ) : (
            <IonPopover
              mode="ios"
              id="fontModal"
              showBackdrop={false}
              isOpen={this.state.fontModalVisible}
              event={this.state.fontModalEvent}
              backdropDismiss={true}
              onDidDismiss={() => this.toggleFontModal(false, null)}
            >
              <div className="triangle" />
              <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
            </IonPopover>
          )}

          <ImageViewerModal
            isOpen={this.state.imageModalVisible}
            isBookmarked={isBookmarked}
            isReferenceCard={false}
            imageSrc={this.state.imageSrc}
            toggleImageModal={this.toggleImageModal.bind(this)}
            bookmarkButtonPressed={this.bookmarkButtonPressed.bind(this)}
            tab={this.props.match.params.tab}
          />
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(withIonLifeCycle(PathwayPage));
